import api from './index';

export default {
  getAll(params = {}) {
    return api.get('/invoices', { params });
  },
  create(data) {
    return api.post('/invoices', data);
  },
  update(id, data) {
    return api.put(`/invoices/${id}`, data);
  },
  createShareLink(id) {
    return api.post(`/invoices/${id}/share-link`);
  },
  getPublicByToken(token) {
    return api.get(`/public/invoices/${token}`);
  },
};
